import { ADJUSTER_REPORT_DAMAGED_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import EditBankAccount from '@/modules/adjusterReportModules/IncidentParticipants/components/bankAccount/bankAccount/EditBankAccount';
import ShowBankAccount from '@/modules/adjusterReportModules/IncidentParticipants/components/bankAccount/showBankAccount/ShowBankAccount';
import ContactOtherDamaged from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/otherDamaged/ContactOtherDamaged';
import InitialOtherDamaged from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/otherDamaged/InitialOtherDamaged';
import CertificateInformation from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/propertyDamage/driver/CertificateInformation';
import ContactInfo from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/propertyDamage/driver/ContactInfo';
import InitialDataDriver from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/propertyDamage/driver/InitialDataDriver';
import { OwnerContract } from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/propertyDamage/owner/contract/OwnerContract';
import { OwnerUserInformation } from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/propertyDamage/owner/user-information/OwnerUserInformation';
import InsuranceInformationWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/propertyInsurance/editPropertyInsurance/EditPropertyInsurance';
import CulpritVehicleInformationPartOne from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/partOne/PartOne';
import VehicleInformationPartTwoWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/partTwo/PartTwo';
import ShowVehicleInformationWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/showVehicleInformation/ShowVehicleInformation';
import DamagedInformationTabPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/DamagedInformationTabPage';
import DamagedListPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/damageList/DamagedListPage';
import BankAccount from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/bank-account/BankAccount';
import DriverInfo from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/driverInfo/DriverInfo';
import OtherDamagedInfo from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/otherDamagedInfo/OtherDamagedInfo';
import OwnerInfo from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/ownerInfo/OwnerInfo';
import ShowIncidentParticipantsData from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/showIncidentParticipantsInfo/ShowIncidentParticipantsInfo';
import CostsPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/costs/CostsPage';
import OtherCosts from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/costs/OtherCosts';
import ShowCosts from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/costs/ShowCosts';
import ShowOtherCosts from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/costs/ShowOtherCosts';
import Expert from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/Expert';
import SubstitutionParts from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/substitutionParts/SubstitutionParts';
import SubstiutionPartsForm from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/substitutionParts/SubstiutionPartsForm';
import OtherDamagedVisitInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/visitInformation/otherDamaged/OtherDamagedVisitInformation';
import OtherShowVisitInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/visitInformation/otherDamaged/OtherShowVisitInformation';
import VehicleShowVisitInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/visitInformation/vehicle/VehicleShowVisitInformation';
import VehicleVisitInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/visitInformation/vehicle/VehicleVisitInformation';
import WagesPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/expert/wages/WagesPage';
import PropertyInsurance from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/property-insurance/PropertyInsurance';
import VehicleInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/vehicleInformation/VehicleInformation';
import { PropertyInsuranceEnum } from '@/modules/adjusterReportModules/IncidentParticipants/types/PropertyInsurance.type';
import { VehicleInformationEnum } from '@/modules/adjusterReportModules/IncidentParticipants/types/VehicleInformationType';
import { Outlet, RouteObject } from 'react-router-dom';

export const DAMAGED_VEHICLE_INFORMATION_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.VEHICLE_INFORMATION.EDIT
      .base,
    element: (
      <VehicleInformation>
        <Outlet />
      </VehicleInformation>
    ),
    children: [
      {
        index: true,
        element: (
          <CulpritVehicleInformationPartOne
            type={VehicleInformationEnum.damaged}
          />
        ),
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.VEHICLE_INFORMATION.EDIT
          .partTwo,
        element: (
          <VehicleInformationPartTwoWrapper
            type={VehicleInformationEnum.damaged}
          />
        ),
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.VEHICLE_INFORMATION.show,
    element: (
      <ShowVehicleInformationWrapper type={VehicleInformationEnum.damaged} />
    ),
  },
];

export const DAMAGED_DRIVER_OWNER_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.EDIT.driver,
    element: (
      <DriverInfo>
        <InitialDataDriver />
      </DriverInfo>
    ),
  },
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.EDIT
      .certificate,
    element: (
      <DriverInfo>
        <CertificateInformation />
      </DriverInfo>
    ),
  },
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.EDIT
      .driverContact,
    element: (
      <DriverInfo>
        <ContactInfo />
      </DriverInfo>
    ),
  },
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.EDIT.owner,
    element: (
      <OwnerInfo>
        <Outlet />
      </OwnerInfo>
    ),
    children: [
      {
        index: true,
        element: <OwnerUserInformation />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.EDIT
          .ownerContact,
        element: <OwnerContract />,
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.show,
    element: <ShowIncidentParticipantsData />,
  },
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.EDIT
      .otherDamaged,
    element: (
      <OtherDamagedInfo>
        <Outlet />
      </OtherDamagedInfo>
    ),
    children: [
      {
        index: true,
        element: <InitialOtherDamaged />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.EDIT
          .otherDamagedContact,
        element: <ContactOtherDamaged />,
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.otherShow,
    element: <ShowIncidentParticipantsData />,
  },
];

export const DAMAGED_EXPERT_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT.base,
    children: [
      { index: true, element: <Expert /> },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT
          .otherVisitInformation,
        element: <OtherDamagedVisitInformation />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT
          .otherVisitInformationShow,
        element: <OtherShowVisitInformation />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT
          .substitutionParts,
        children: [
          {
            index: true,
            element: <SubstitutionParts />,
          },
          {
            path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT
              .substitutionPartsForm,
            element: <SubstiutionPartsForm />,
          },
        ],
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT
          .substitutionPartsShow,
        element: <SubstitutionParts isEditable={false} />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT.visitInformation,
        element: <VehicleVisitInformation />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT
          .visitInformationShow,
        element: <VehicleShowVisitInformation />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT.wages,
        element: <WagesPage />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT.wagesShow,
        element: <WagesPage isEditable={false} />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT.costs,
        element: <CostsPage />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT.otherCosts,
        element: <OtherCosts />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT.otherCostsShow,
        element: <ShowOtherCosts />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.EXPERT.costsShow,
        element: <ShowCosts />,
      },
    ],
  },
];

export const DAMAGED_BANK_ACCOUNT_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.BANK_ACCOUNT.edit,
    element: (
      <BankAccount>
        <Outlet />
      </BankAccount>
    ),
    children: [
      {
        index: true,
        element: <EditBankAccount />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.BANK_ACCOUNT.show,
        element: <ShowBankAccount />,
      },
    ],
  },
];

export const DAMAGED_PROPERTY_INSURANCE_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.PROPERTY_INSURANCE.edit,
    element: (
      <PropertyInsurance>
        <Outlet />
      </PropertyInsurance>
    ),
    children: [
      {
        index: true,
        element: (
          <InsuranceInformationWrapper type={PropertyInsuranceEnum.damaged} />
        ),
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.PROPERTY_INSURANCE.show,
        element: (
          <InsuranceInformationWrapper type={PropertyInsuranceEnum.damaged} />
        ),
      },
    ],
  },
];

export const ADJUSTER_REPORT_DAMAGED_INFORMATION_ROUTES: RouteObject[] = [
  {
    path: ':damagedId',
    children: [
      { index: true, element: <DamagedInformationTabPage /> },
      ...DAMAGED_DRIVER_OWNER_ROUTES,
      ...DAMAGED_EXPERT_ROUTES,
      ...DAMAGED_VEHICLE_INFORMATION_ROUTES,
      ...DAMAGED_BANK_ACCOUNT_ROUTES,
      ...DAMAGED_PROPERTY_INSURANCE_ROUTES,
    ],
  },
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.list,
    element: <DamagedListPage state="information" />,
  },
];
